import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleCheck = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			fill: "#DEF7EC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.25 12.5C2.25 7.11522 6.61522 2.75 12 2.75C17.3848 2.75 21.75 7.11522 21.75 12.5C21.75 17.8848 17.3848 22.25 12 22.25C6.61522 22.25 2.25 17.8848 2.25 12.5Z",
			stroke: "#31C48D",
			strokeWidth: .5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.5911 16.7046H10.5811C10.311 16.7046 10.056 16.5895 9.87094 16.3995L6.28025 12.6688C5.89517 12.2687 5.91017 11.6386 6.30525 11.2535C6.70033 10.8684 7.33545 10.8834 7.72052 11.2785L10.6061 14.2741L16.2922 8.588C16.6822 8.19792 17.3174 8.19792 17.7074 8.588C18.0975 8.97807 18.0975 9.61319 17.7074 10.0033L11.2962 16.4095C11.1062 16.5995 10.8561 16.7046 10.5911 16.7046Z",
			fill: "#03543F"
		})
	]
});
export default SvgCircleCheck;
